module.exports = __webpack_public_path__ + "img/banner_4.001d345b.jpg";